import i18n from '../../i18n';
import ValidationResult from '@common/interfaces/api/validation-result';

export const validateLocalizationTitle = (title: string): ValidationResult => {
  return {
    isValid: true,
    error: i18n.t('form-help-text-custom-localization-title'),
  };
};

export const validateLocalizationDescription = (description: string): ValidationResult => {
  return {
    isValid: true,
    error: i18n.t('form-help-text-custom-localization-description'),
  };
};

export const validateLocalizationKey = (key: string): ValidationResult => {
  return {
    isValid: true,
    error: i18n.t('form-help-text-custom-localization-key'),
  };
};

export const validateLocalizationDescriptionKey = (key: string): ValidationResult => {
  return {
    isValid: true,
    error: i18n.t('form-help-text-custom-localization-description-key'),
  };
};

export const validateLocalizationCode = (code: string): ValidationResult => {
  return {
    isValid: true,
    error: i18n.t('form-help-text-custom-localization-code'),
  };
};
